import React from "react"
import { Link } from "gatsby"
import BackgroundImage from 'gatsby-background-image'

import PublishingDetails from "./PublishingDetails"

const ListLayout = (props) => {
  const {
    edges,
    imageNodes,
    showImage,
    showSubtitle
  } = props

  return (
    <>
      <div className="flex flex-col">
        {edges.map(edge => {
          const post = edge.node.childMarkdownRemark.frontmatter
          const image = imageNodes.find(node => node.relativePath.slice(7) === post.coverPhoto)

          return (
            <div
              key={edge.node.id}
              className="w-full p-3 flex"
            >
              <Link
                to={post.path}
                className="w-full shadow rounded overflow-hidden hover:bg-gray-200 flex"
              >
                <div className="lg:w-56 md:w-40 sm:w-32 w-24" style={{ minWidth: '6rem' }}>
                  {image && showImage ? (
                    <BackgroundImage
                      fluid={image.childImageSharp.fluid}
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                    />
                  ) : null}
                </div>
                <div className="flex flex-col">
                  <h6 className="font-bold px-3 pt-3">
                    {post.title}
                  </h6>
                  {showSubtitle ? (
                    <p className="sm:p-3 px-3 text-gray-600">
                      {post.subtitle || <>&nbsp;</>}
                    </p>
                  ) : null}
                  <div className="mt-auto">
                    <PublishingDetails publishDate={post.publishDate} category={post.category} />
                  </div>
                </div>
              </Link>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default ListLayout
